// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Form } from "metabase/forms";

export const GoogleForm = styled(Form)`
  margin: 0 1rem;
  max-width: 32.5rem;
`;

export const GoogleFormHeader = styled.h2`
  margin-top: 1rem;
`;

export const GoogleFormCaption = styled.p`
  color: var(--mb-color-text-medium);
`;
